<template>
    <div>
        <!-- 卡片弹出层 -->
        <van-popup v-model="card_show" class="pop_card">
            <img :src="imgLink" alt="请稍等图片正在加载">
            <h3>{{h3}}</h3>
            <h4>{{h4}}</h4>
        </van-popup>
    </div>
</template>

<script>
export default {
    data(){
        return{
            card_show:false,
        }
    },
    props:{
        imgLink:{
            type:String,
            default:''
        },
        h3:{
            type:String,
            default:''
        },
        h4:{
            type:String,
            default:''
        }

    }
}
</script>

<style lang="scss" scoped>
    // 弹出卡片
    .pop_card{
        background-color: transparent;
        text-align: center;
        img{
            width: 600px;
        }
        h3{
            margin-top: 40px;
            color: #fff;
            font-size:26px;
            background-color: transparent;
        }
        h4{
            font-size: 20px;
            margin-top: 20px;
            color: #fff;
        }
    }
</style>
